import React from 'react';
import { DateTime } from 'luxon';
import {
  formatCurrency,
  formatPercent,
} from '../../../../lib/utils/formatters';
import {
  fromISO,
  reformatDate,
} from '../../../../lib/utils/datetime_formatters';
export default function PrimarySlide({ product, order, merchant }) {
  const isPaymentPlan = order?.product_type !== 'mambu_loan';
  const daysPastDue = () => {
    let today = DateTime.now();
    let due_date = fromISO(
      isPaymentPlan ? product?.last_past_due_at : product?.last_past_due_date,
    );
    return Math.round(today.diff(due_date, 'days').toObject().days) || 'N/A';
  };
  return (
    <div className="flex justify-between items-start capitalize">
      <div className="mx-4">
        <p>order ID: {product?.order_key}</p>
        <p>
          {isPaymentPlan ? 'payment plan' : 'loan'} ID: {product?.id}
        </p>
        <p>created date: {fromISO(order?.created_at).toLocaleString()} </p>
        <p>
          Disbursement date:{' '}
          {reformatDate(
            isPaymentPlan ? product?.disbursement_date : product?.capture_date,
          )}
        </p>
        <p>number of installments: {product?.installments}</p>
        <p>
          interest free months:{' '}
          {isPaymentPlan
            ? product?.interest_free_intervals
            : product?.interest_free_months}
        </p>
      </div>
      <div className="mx-4">
        <p>type: {order?.product_type.replaceAll('_', ' ')}</p>
        <p>
          monthly payment amount:{' '}
          {isPaymentPlan
            ? formatCurrency(product?.next_payment_due_amount || 0)
            : formatCurrency(product?.next_payment_amount)}
        </p>
        <p>merchant fee: {formatCurrency(product?.merchant_fee_amount)}</p>
        <p>
          merchant rate:{' '}
          {formatPercent(
            isPaymentPlan
              ? product?.merchant_fee_percent * 100
              : product?.merchant_fee * 100,
          )}
        </p>
        <p>merchant name: {merchant?.name}</p>
        <p>borrower fee: {formatPercent((isPaymentPlan ? product?.processing_fee_percent : product?.borrower_fee) * 100)}</p>
      </div>
      <div className="mx-4">
        <p>
          {isPaymentPlan ? 'payment plan' : 'loan'} monthly fee:{' '}
          {formatCurrency(
            isPaymentPlan
              ? (product?.amount - product?.total_amount_refunded) *
                  product?.interest_fee_percent
              : product?.monthly_fee.cents / 100,
          )}
        </p>
        <p>
          {isPaymentPlan ? 'payment plan' : 'loan'} monthly interest:{' '}
          {formatPercent(
            isPaymentPlan
              ? product?.interest_fee_percent * 100
              : product?.monthly_interest,
          )}
        </p>
        <p>payoff balance: {formatCurrency(product?.payoff_balance)}</p>
        <p>days late: {daysPastDue()}</p>
        <p>
          amount refunded:{' '}
          {formatCurrency(
            isPaymentPlan
              ? product?.total_amount_refunded
              : product?.amount_refunded,
          )}
        </p>
        <p>settled amount: {formatCurrency(product?.settled_amount)}</p>
      </div>
    </div>
  );
}
